import { render, staticRenderFns } from "./PLPProductBox.vue?vue&type=template&id=0e53fb4e&scoped=true"
import script from "./PLPProductBox.vue?vue&type=script&lang=ts"
export * from "./PLPProductBox.vue?vue&type=script&lang=ts"
import style0 from "./PLPProductBox.vue?vue&type=style&index=0&id=0e53fb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53fb4e",
  null
  
)

export default component.exports